// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ZElYa","title":"AfterBackImages_title__3SCIg","images":"AfterBackImages_images__1Wcxh"};